export default "__VITE_ASSET__CJ9Mi1Up__"